import { render, staticRenderFns } from "./DIASSellersPreview.vue?vue&type=template&id=841b9494&"
import script from "./DIASSellersPreview.vue?vue&type=script&lang=js&"
export * from "./DIASSellersPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports